/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { StarIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/xdp';

const styles = {
  itemTitle: () => css`
    padding: var(--cds-spacing-100) 0;
  `,
  icon: css`
    display: block;
  `,
};

const ExclusiveDetailItem = () => {
  return (
    <React.Fragment>
      <StarIcon size="large" css={styles.icon} />
      <Typography2 variant="subtitleMedium" css={styles.itemTitle} component="div">
        {_t('Exclusive')}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary" color="supportText">
        {_t('Available only for your organization')}
      </Typography2>
    </React.Fragment>
  );
};

export default ExclusiveDetailItem;
